var bmProductDetails = (function () {
    function bmProductDetails(args) {
        this.uiElements = {
            productCarsModal: null,
            productCarsLink: null,
            form: null,
            importBtn: null,
            importBtnLoading: null
        };
        this._args = null;
        this._args = args;
        this.uiElements.productCarsModal = $("#product-cars-modal");
        this.uiElements.productCarsLink = $(".product-cars-link");
        this.uiElements.form = $("#import-product-form");
        this.uiElements.importBtn = $("#importProductBtn");
        this.uiElements.importBtnLoading = $("#importProductBtnLoading");
        $('.characteristic-item [data-toggle="tooltip"]').tooltip();
        this.subscribeToEvents();
    }
    bmProductDetails.prototype.subscribeToEvents = function () {
        var _this = this;
        this.uiElements.productCarsLink.click(function (e) {
            _this.uiElements.productCarsModal.modal("show");
        });
        this.uiElements.importBtn.click(function (e) {
            _this.importProduct();
        });
        $(".product-thumbs__item").click(function (e) {
            _this.switchImage($(e.currentTarget));
            e.preventDefault();
        });
        $("#mainImageLink").click(function (e) {
            var currentImageUrl = $(e.currentTarget).find("img").attr("src");
            var imagesArray = [{
                    src: currentImageUrl,
                }];
            $(".product-thumbs__item a").each(function (i, el) {
                var thumbUrl = $(el).attr("href");
                if (currentImageUrl !== thumbUrl) {
                    imagesArray.push({
                        src: thumbUrl,
                    });
                }
            });
            $.fancybox.open(imagesArray, {
                protect: true,
                loop: true
            });
        });
    };
    bmProductDetails.prototype.switchImage = function (thumb) {
        $('.product-thumbs__item').removeClass('product-thumbs__item--active');
        var bigUrl = $('a', thumb).attr('href');
        thumb.addClass('product-thumbs__item--active');
        $('.mainImage img').attr('src', bigUrl);
    };
    bmProductDetails.prototype.importProduct = function () {
        var _this = this;
        var url = this.uiElements.form.attr("action");
        this.uiElements.importBtn.prop("disabled", true);
        this.uiElements.importBtnLoading.show();
        $.post(url, this.uiElements.form.serialize()).done(function () {
            $.notify({ message: "Товар успешно добавлен" }, { type: "success" });
            _this.uiElements.importBtnLoading.hide();
        });
    };
    return bmProductDetails;
}());
var bmProductDetailsArgs = (function () {
    function bmProductDetailsArgs() {
    }
    return bmProductDetailsArgs;
}());
function appAjaxAreaLoading($area, deffered) {
    var fadeDuration = 250;
    var fadeColor = "white";
    if ($area.length <= 0)
        return;
    var tbodyPos = $area.position();
    var divOverlay = $("<div data-loading-overlay=''></div>");
    divOverlay.css({
        position: "absolute",
        "background-color": fadeColor,
        display: "none",
        top: tbodyPos.top,
        left: tbodyPos.left,
        width: $area.width() - 1,
        height: $area.height()
    });
    $area.before(divOverlay);
    divOverlay.fadeIn({ duration: fadeDuration });
    deffered.always(function () {
        divOverlay.fadeOut({
            duration: fadeDuration,
            complete: function () { divOverlay.remove(); }
        });
    });
}
var appAjaxSetup = (function () {
    function appAjaxSetup() {
        var _this = this;
        $(document).ajaxComplete(function (event, XMLHttpRequest) {
            var isAjaxRedirect = XMLHttpRequest.getResponseHeader('AjaxRedirect') === "1";
            if (isAjaxRedirect) {
                _this.ajaxRedirect(XMLHttpRequest);
                return;
            }
            site.init();
        });
        $(document).ajaxError(function (event, jqXHR) {
            $.notify({ message: "Unhandled Error: ".concat(jqXHR.responseText) }, { type: 'danger', delay: 7000 });
        });
    }
    appAjaxSetup.prototype.ajaxRedirect = function (jqXHR) {
        var redirectUrl = jqXHR.getResponseHeader('location');
        var pathAndQuery = redirectUrl.split('?');
        if (pathAndQuery.length === 2) {
            var queryArgs = pathAndQuery[1].split('&');
            var isUrlChanged = false;
            for (var i = 0; i < queryArgs.length; i++) {
                if (queryArgs[i].indexOf("ReturnUrl=") === 0) {
                    var rootPath = window.location.protocol + "//" + window.location.host + "/";
                    queryArgs[i] = "ReturnUrl=" + encodeURIComponent("/" + window.location.href.replace(rootPath, ""));
                    isUrlChanged = true;
                    break;
                }
            }
            if (isUrlChanged) {
                pathAndQuery[1] = queryArgs.join('&');
                redirectUrl = pathAndQuery.join('?');
            }
        }
        window.location.href = redirectUrl;
    };
    return appAjaxSetup;
}());
var appEventListener = (function () {
    function appEventListener() {
    }
    appEventListener.prototype.trigger = function (type, data) {
        $(site).trigger(type, data);
    };
    ;
    appEventListener.prototype.on = function (type, callback, disposeContext) {
        if (!callback) {
            throw new Error('EventListener.on callback is undefined');
        }
        if (disposeContext) {
            $(disposeContext).on("remove", function () {
                $(site).off(type, callback);
            });
        }
        $(site).on(type, callback);
    };
    ;
    appEventListener.prototype.off = function (type) {
        return $(site).off(type);
    };
    ;
    return appEventListener;
}());
var eventListener = new appEventListener();
var appFilterControl = (function () {
    function appFilterControl(container) {
        this.events = $(this);
        this.uiElements = {
            container: null,
            form: null,
            btnApply: null,
            btnClear: null
        };
        this.on = $.proxy(this.events.on, this.events);
        this.off = $.proxy(this.events.off, this.events);
        this.uiElements.container = container;
        this.initUi();
        this.subscribeToEvents();
        this.refreshHighlights();
    }
    appFilterControl.prototype.getFilteredColumns = function () {
        var columns = [];
        this.getNonEmptyFilterControls()
            .each(function (index, elem) {
            var column = $(elem).attr("data-highlight-column") || $(elem).attr("name");
            if (column) {
                var splitted = column.split(",");
                for (var i = 0; i < splitted.length; i++) {
                    columns.push(splitted[i]);
                }
            }
        });
        return columns;
    };
    appFilterControl.prototype.subscribeToEvents = function () {
        var _this = this;
        this.getFilterControls().change(function () { _this.updateClearButtonStatus(); });
        $(":input[autocomplete]", this.uiElements.container).keyup(function () { _this.updateClearButtonStatus(); });
        this.uiElements.btnApply.click(function (e) {
            e.preventDefault();
            _this.submitFilter();
        });
        this.uiElements.form.submit(function (e) {
            e.preventDefault();
            _this.submitFilter();
        });
        this.uiElements.btnClear.click(function (e) {
            e.preventDefault();
            if (_this.uiElements.btnClear.attr("disabled") === "disabled")
                return;
            _this.getFilterControls().val(null);
            _this.updateClearButtonStatus();
            _this.submitFilter();
        });
    };
    appFilterControl.prototype.submitFilter = function () {
        var args = { filterData: this.getFormData(this.uiElements.form), filteredColumns: this.getFilteredColumns() };
        this.events.trigger("filter-control-changed", args);
        this.refreshHighlights();
    };
    appFilterControl.prototype.getFormData = function ($form) {
        var unindexedArray = $form.serializeArray();
        var indexedArray = {};
        $.map(unindexedArray, function (n, i) {
            indexedArray[n['name']] = n['value'];
        });
        return indexedArray;
    };
    appFilterControl.prototype.updateClearButtonStatus = function () {
        var isNonEmpty = this.getNonEmptyFilterControls().length > 0;
        this.uiElements.btnClear.prop("disabled", !isNonEmpty);
    };
    appFilterControl.prototype.refreshHighlights = function () {
        var _this = this;
        this.updateClearButtonStatus();
        this.getFilterControls().each(function (i, el) { return _this.highlightFilterElement($(el)); });
    };
    appFilterControl.prototype.highlightFilterElement = function ($element) {
        $element.toggleClass("highlight", this.isNonEmptyFilterControl($element));
    };
    appFilterControl.prototype.getFilterControls = function () {
        return $(":input", this.uiElements.container);
    };
    appFilterControl.prototype.getNonEmptyFilterControls = function () {
        var _this = this;
        return this.getFilterControls()
            .filter(function (i, elem) { return _this.isNonEmptyFilterControl(elem); });
    };
    appFilterControl.prototype.isNonEmptyFilterControl = function (elem) {
        return $(elem).val() !== "";
    };
    appFilterControl.prototype.initUi = function () {
        this.uiElements.btnApply = $("[data-apply]", this.uiElements.container);
        this.uiElements.btnClear = $("[data-clear]", this.uiElements.container);
        this.uiElements.form = this.uiElements.container;
    };
    return appFilterControl;
}());
var appPagingSorting = (function () {
    function appPagingSorting(containerSelector, url, filterFormSelector) {
        var _this = this;
        this.uiElements = {
            container: null,
            getTable: null,
            getState: null
        };
        this.filter = null;
        this.containerSelector = containerSelector;
        this.url = url;
        this.filterFormSelector = filterFormSelector;
        this.uiElements.container = $(".paging-sorting-update", $(containerSelector));
        if (this.uiElements.container.length === 0) {
            var errMsg = ".paging-sorting-update not found in container '".concat(containerSelector, "' or container not found");
            alert(errMsg);
            throw new Error(errMsg);
        }
        this.uiElements.getTable = function () { return $("table.paging-sorting", _this.uiElements.container); };
        this.uiElements.getState = function () { return $("[data-paging-sorting-state]", _this.uiElements.container); };
        this.initFilterControl();
        this.subscribeToEvents();
    }
    appPagingSorting.prototype.initFilterControl = function () {
        var filterContainer;
        if (this.filterFormSelector) {
            filterContainer = $(this.filterFormSelector);
        }
        else {
            filterContainer = $(".paging-sorting-filter-form", $(this.containerSelector));
        }
        if (filterContainer.length > 0) {
            this.filter = new appFilterControl(filterContainer);
            this.refreshHighlights();
        }
    };
    appPagingSorting.prototype.refreshHighlights = function () {
        if (this.filter) {
            this.highlightTableColumns(this.filter.getFilteredColumns());
        }
    };
    appPagingSorting.prototype.highlightTableColumns = function (columns) {
        $("[data-sortmember]", this.uiElements.container).each(function (index, elem) {
            var $this = $(elem);
            var currentColumn = $this.attr("data-sortmember");
            $this.toggleClass("highlight", columns.indexOf(currentColumn) >= 0);
        });
    };
    appPagingSorting.prototype.sendRequest = function (data, keepPaging) {
        var parametesData = this.getState();
        data = appSerializeObject(data);
        if (data) {
            $.extend(parametesData, data);
        }
        if (!keepPaging) {
            $.extend(parametesData.PagingSortingInfo, { Page: 1 });
        }
        return this.ajaxRequest(parametesData);
    };
    appPagingSorting.prototype.subscribeToEvents = function () {
        var _this = this;
        this.subscribeToPaging();
        this.subscribeToSorting();
        if (this.filter) {
            this.filter.on("filter-control-changed", function (e, args) {
                _this.sendRequest(args.filterData, true);
            });
        }
    };
    appPagingSorting.prototype.subscribeToPaging = function () {
        var _this = this;
        this.uiElements.container.on("click", "a[data-Page]", function (event) {
            var $this = $(event.currentTarget);
            var page = $this.attr("data-Page");
            var data = { Page: page };
            _this.pagingSortingChanged(data);
        });
    };
    appPagingSorting.prototype.subscribeToSorting = function () {
        var _this = this;
        this.uiElements.container.on("click", ".paging-sorting th[data-SortMember]", function (event) {
            var $this = $(event.currentTarget);
            var sortMember = $this.attr("data-SortMember");
            var sortDescending = $this.attr("data-SortDescending");
            var data = {
                SortMember: sortMember,
                SortDescending: sortDescending
            };
            _this.pagingSortingChanged(data);
        });
    };
    appPagingSorting.prototype.pagingSortingChanged = function (changedData) {
        var parametesData = this.getState();
        var pagingSortingInfoData = parametesData["PagingSortingInfo"];
        $.extend(pagingSortingInfoData, changedData);
        parametesData["PagingSortingInfo"] = pagingSortingInfoData;
        this.ajaxRequest(parametesData);
    };
    appPagingSorting.prototype.getState = function () {
        var stateControl = this.uiElements.getState();
        if (stateControl.length <= 0)
            return null;
        return JSON.parse(stateControl.attr("data-paging-sorting-state"));
    };
    appPagingSorting.prototype.ajaxRequest = function (data) {
        var _this = this;
        var deff = $.ajax({
            url: this.url,
            data: data,
            cache: false,
            type: "POST",
        })
            .done(function (html) {
            _this.uiElements.container.empty().append(html);
        })
            .always(function () {
            _this.refreshHighlights();
        });
        appAjaxAreaLoading(this.uiElements.getTable().find("tbody"), deff);
        return deff.promise();
    };
    return appPagingSorting;
}());
function appSerializeObject(object, forseNotValidate) {
    if (forseNotValidate === void 0) { forseNotValidate = false; }
    if ($.isPlainObject(object)) {
        return object;
    }
    var serializeArray;
    if ($.isArray(object)) {
        serializeArray = object;
    }
    else {
        var inputs = $(object).find(":input");
        serializeArray = inputs.serializeArray();
        inputs.filter("select.multiselect").each(function () {
            if (!$(this).val() || !$(this).val().length) {
                var name_1 = $(this).attr("id");
                var nameExistInArray = false;
                for (var i = 0; i < serializeArray.length; i++) {
                    if (serializeArray[i].name === name_1) {
                        nameExistInArray = true;
                        break;
                    }
                }
                if (!nameExistInArray) {
                    serializeArray.push({
                        name: name_1,
                        value: "<CREATE_EMPTY_ARRAY>"
                    });
                }
            }
        });
    }
    var self = this, json = {}, pushCounters = {}, patterns = {
        "validate": /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
        "key": /[a-zA-Z0-9_]+|(?=\[\])/g,
        "push": /^$/,
        "fixed": /^\d+$/,
        "named": /^[a-zA-Z0-9_]+$/
    };
    this.build = function (base, key, value) {
        base[key] = value;
        return base;
    };
    this.push_counter = function (key) {
        if (pushCounters[key] === undefined) {
            pushCounters[key] = 0;
        }
        return pushCounters[key]++;
    };
    $.each(serializeArray, function () {
        if (!forseNotValidate) {
            if (!patterns.validate.test(this.name)) {
                return;
            }
        }
        var k, keys = this.name.match(patterns.key), merge = this.value, reverse_key = this.name;
        while ((k = keys.pop()) !== undefined) {
            reverse_key = reverse_key.replace(new RegExp("\\[" + k + "\\]$"), '');
            if (k.match(patterns.push)) {
                merge = self.build([], self.push_counter(reverse_key), merge);
            }
            else if (k.match(patterns.fixed)) {
                merge = self.build([], k, merge);
            }
            else if (k.match(patterns.named)) {
                merge = self.build({}, k, merge);
            }
        }
        if (this.value === "<CREATE_EMPTY_ARRAY>") {
            json[this.name] = [];
        }
        else {
            if ((this.name in json)) {
                if (!(Object.prototype.toString.call(json[this.name]) === '[object Array]')) {
                    json[this.name] = [json[this.name]];
                }
                json[this.name].push(this.value);
            }
            else {
                json = $.extend(true, json, merge);
            }
        }
    });
    return json;
}
function appShowScriptMessages() {
    var scriptMessagesBase64 = $.cookie("SiteScriptMessage");
    if (scriptMessagesBase64) {
        $.cookie("SiteScriptMessage", null, { path: "/", expires: -1 });
    }
    if (scriptMessagesBase64 && scriptMessagesBase64 != "") {
        var scriptMessagesJson = Base64.decode(scriptMessagesBase64);
        showScriptMessages(scriptMessagesJson);
    }
    function showScriptMessages(jsonString) {
        var json = $.parseJSON(jsonString);
        if (json) {
            var scriptItems = [];
            if (json.length) {
                scriptItems = json;
            }
            for (var i = 0; i < scriptItems.length; i++) {
                var message = scriptItems[i];
                evaluateScriptMessage(message.Message, message.MessageDataType, message.MessageTypeString);
            }
        }
    }
    function evaluateScriptMessage(message, dataType, dataMessageType) {
        if (dataType === 'messsage') {
            var delay = 2000;
            if (dataMessageType === 'danger')
                delay = 7000;
            $.notify({ message: message }, { type: dataMessageType, delay: delay });
        }
        else if (dataType === 'script') {
            eval(message);
        }
        else {
            throw new Error("Unknown message dataType - ".concat(dataType));
        }
    }
}
var appUtils = (function () {
    function appUtils() {
    }
    appUtils.prototype.htmlEncode = function (value) {
        return $('<div/>').text(value).html();
    };
    appUtils.prototype.htmlToText = function (value) {
        return $('<div/>').html(value).text();
    };
    appUtils.prototype.readCookieRaw = function (name) {
        var raw = $.cookie.raw;
        try {
            $.cookie.raw = true;
            var result = $.cookie(name);
            $.cookie.raw = raw;
            return result;
        }
        catch (e) {
            $.cookie.raw = raw;
            throw e;
        }
    };
    appUtils.prototype.autofocus = function () {
        var $focus = $("[data-focus]").not("[data-focus-placed='true']");
        if ($focus.length > 0) {
            $focus.attr("data-focus-placed", "true");
            this.focusOnElement($focus);
        }
    };
    appUtils.prototype.focusOnElement = function ($focus) {
        var doc = document;
        var elem = $focus[0];
        var elemLen = elem.value.length;
        if (doc.selection) {
            elem.focus();
            var oSel = doc.selection.createRange();
            oSel.moveStart('character', -elemLen);
            oSel.moveStart('character', elemLen);
            oSel.moveEnd('character', 0);
            oSel.select();
        }
        else if (elem.selectionStart || elem.selectionStart == '0') {
            elem.selectionStart = elemLen;
            elem.selectionEnd = elemLen;
            elem.focus();
        }
    };
    return appUtils;
}());
var appValidators = (function () {
    function appValidators() {
        var defaultOptions = {
            ignore: ":hidden:not([data-validatehidden])"
        };
        $.validator.setDefaults(defaultOptions);
        $.validator.methods.range = function (value, element, param) {
            var globalizedValue = value.replace(",", ".");
            return this.optional(element) || (globalizedValue >= param[0] && globalizedValue <= param[1]);
        };
        $.validator.methods.number = function (value, element) {
            return this.optional(element) || /^-?(?:\d+|\d{1,3}(?:[\s\.,]\d{3})+)(?:[\.,]\d+)?$/.test(value);
        };
    }
    appValidators.prototype.refreshValidators = function (containerSelector) {
        var $forms = $(containerSelector);
        if (!$forms.is("form")) {
            $forms = $forms.find("form");
        }
        $forms.validateBootstrap(true);
    };
    return appValidators;
}());
var appDialogs = (function () {
    function appDialogs() {
        this.saveFormDialog = appSaveFormDialog;
        this.alert = appAlertDialog;
        this.confirm = appConfirmDialog;
    }
    return appDialogs;
}());
var appSite = (function () {
    function appSite() {
        _.templateSettings.variable = "model";
        $.fn.select2.defaults.set("theme", "bootstrap");
        $.fn.select2.defaults.set("dropdownAutoWidth", true);
        this.appAjaxSetup = new appAjaxSetup();
        this.validators = new appValidators();
        this.dialogs = new appDialogs();
        this.utils = new appUtils();
        $(document).ready(function () {
            site.init();
        });
    }
    appSite.prototype.init = function () {
        appShowScriptMessages();
        new appControlAutocomplete().init();
        this.utils.autofocus();
    };
    return appSite;
}());
var site = new appSite();
var appTilePagingSorting = (function () {
    function appTilePagingSorting(containerSelector, url, filterFormSelector) {
        var _this = this;
        this.uiElements = {
            container: null,
            getListContainer: null,
            getState: null
        };
        this.filter = null;
        this.containerSelector = containerSelector;
        this.url = url;
        this.filterFormSelector = filterFormSelector;
        this.uiElements.container = $(".paging-sorting-update", $(containerSelector));
        if (this.uiElements.container.length === 0) {
            var errMsg = ".paging-sorting-update not found in container '".concat(containerSelector, "' or container not found");
            alert(errMsg);
            throw new Error(errMsg);
        }
        this.uiElements.getListContainer = function () { return $(".paging-sorting", _this.uiElements.container); };
        this.uiElements.getState = function () { return $("[data-paging-sorting-state]", _this.uiElements.container); };
        this.initFilterControl();
        this.subscribeToEvents();
    }
    appTilePagingSorting.prototype.initFilterControl = function () {
        var filterContainer;
        if (this.filterFormSelector) {
            filterContainer = $(this.filterFormSelector);
        }
        else {
            filterContainer = $(".paging-sorting-filter-form", $(this.containerSelector));
        }
        if (filterContainer.length > 0) {
            this.filter = new appFilterControl(filterContainer);
        }
    };
    appTilePagingSorting.prototype.sendRequest = function (data, keepPaging) {
        var parametesData = this.getState();
        data = appSerializeObject(data);
        if (data) {
            $.extend(parametesData, data);
        }
        if (!keepPaging) {
            $.extend(parametesData.PagingSortingInfo, { Page: 1 });
        }
        return this.ajaxRequest(parametesData);
    };
    appTilePagingSorting.prototype.subscribeToEvents = function () {
        var _this = this;
        this.subscribeToPaging();
        this.subscribeToSorting();
        if (this.filter) {
            this.filter.on("filter-control-changed", function (e, args) {
                _this.sendRequest(args.filterData, true);
            });
        }
    };
    appTilePagingSorting.prototype.subscribeToPaging = function () {
        var _this = this;
        this.uiElements.container.on("click", "a[data-Page]", function (event) {
            var $this = $(event.currentTarget);
            var page = $this.attr("data-Page");
            var data = { Page: page };
            _this.pagingSortingChanged(data);
        });
    };
    appTilePagingSorting.prototype.subscribeToSorting = function () {
        var _this = this;
        this.uiElements.container.on("click", ".paging-sorting th[data-SortMember]", function (event) {
            var $this = $(event.currentTarget);
            var sortMember = $this.attr("data-SortMember");
            var sortDescending = $this.attr("data-SortDescending");
            var data = {
                SortMember: sortMember,
                SortDescending: sortDescending
            };
            _this.pagingSortingChanged(data);
        });
    };
    appTilePagingSorting.prototype.pagingSortingChanged = function (changedData) {
        var parametesData = this.getState();
        var pagingSortingInfoData = parametesData["PagingSortingInfo"];
        $.extend(pagingSortingInfoData, changedData);
        parametesData["PagingSortingInfo"] = pagingSortingInfoData;
        this.ajaxRequest(parametesData);
    };
    appTilePagingSorting.prototype.getState = function () {
        var stateControl = this.uiElements.getState();
        if (stateControl.length <= 0)
            return null;
        return JSON.parse(stateControl.attr("data-paging-sorting-state"));
    };
    appTilePagingSorting.prototype.ajaxRequest = function (data) {
        var _this = this;
        var deff = $.ajax({
            url: this.url,
            data: data,
            cache: false,
            type: "POST",
        })
            .done(function (html) {
            _this.uiElements.container.empty().append(html);
        })
            .always(function () {
        });
        appAjaxAreaLoading(this.uiElements.getListContainer(), deff);
        return deff.promise();
    };
    return appTilePagingSorting;
}());
var appControlAutocomplete = (function () {
    function appControlAutocomplete() {
    }
    appControlAutocomplete.prototype.init = function () {
        $("input[data-autocomplete-url]:not(.processed)").each(function (index, elem) {
            var $this = $(elem);
            $this.addClass("processed");
            $this.autocomplete({
                source: function (request, response) {
                    $.ajax({
                        type: "POST",
                        url: $this.attr("data-autocomplete-url"),
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        data: JSON.stringify({ prefixText: request.term, count: ($this.attr("data-itemscount") || '20'), contextKey: ($this.attr("data-contextKey") || "") }),
                        success: function (data) {
                            response($.map(data, function (item) { return ({
                                label: item.Label,
                                value: item.Value
                            }); }));
                        }
                    });
                },
                minLength: 0,
                delay: 100,
                select: function (event, ui) {
                    if (ui.item.value === '[No matches found]')
                        ui.item.value = '';
                },
                open: function () {
                    $this.removeClass("ui-corner-all").addClass("ui-corner-top").addClass("autocompleteOpen");
                },
                close: function (event, ui) {
                    $this.removeClass("ui-corner-top").addClass("ui-corner-all").removeClass("autocompleteOpen");
                    if ($this.attr("data-onautocompleteclose")) {
                        eval($this.attr("data-onautocompleteclose") + "(event, ui)");
                    }
                }
            });
            $this.dblclick(function () {
                $this.autocomplete("search");
            });
        });
    };
    return appControlAutocomplete;
}());
function appAlertDialog(message, onClose, options) {
    var dialog = appDialogShow({
        title: options.title,
        body: message,
        close: onClose,
        dialogClass: options.dialogClass,
        buttons: [
            {
                text: options.okText,
                buttonClass: 'btn-secondary',
                click: function () {
                    dialog.close();
                    if (onClose) {
                        onClose();
                    }
                }
            }
        ]
    });
}
var appAlertDialogOptions = (function () {
    function appAlertDialogOptions() {
        this.dialogClass = "";
        this.title = "";
        this.okText = "OK";
    }
    return appAlertDialogOptions;
}());
function appConfirmDialog(message, onClose, options) {
    var onCloseSafe = function (isConfirmed) {
        if (onClose) {
            onClose(isConfirmed || false);
        }
    };
    var dialog = appDialogShow({
        title: options.title,
        body: message,
        close: onCloseSafe,
        dialogClass: options.dialogClass,
        buttons: [
            {
                text: options.cancelText,
                buttonClass: 'btn-secondary',
                click: function () {
                    dialog.close();
                    onCloseSafe(false);
                }
            },
            {
                text: options.okText,
                buttonClass: 'btn-primary',
                click: function () {
                    dialog.close();
                    onCloseSafe(true);
                }
            }
        ]
    });
}
var appConfirmDialogOptions = (function () {
    function appConfirmDialogOptions() {
        this.dialogClass = "";
        this.title = "";
        this.okText = "OK";
        this.cancelText = "Отмена";
    }
    return appConfirmDialogOptions;
}());
function appDialogShow(options) {
    var modalTemplate = _.template('<div class="modal fade">' +
        '<div class="modal-dialog <%=model.dialogClass%>">'
        + '<div class="modal-content">'
        + "<% if(model.title) { %>"
        + '<div class="modal-header">'
        + '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>'
        + '<h4 class="modal-title"><%= model.title %></h4>'
        + '</div>'
        + "<% } %>"
        + '<div class="modal-body"><%= model.body %></div>'
        + '<% if(model.buttons && model.buttons.length > 0) { %>'
        + '<div class="modal-footer">'
        + '<% for(var i = 0; i < model.buttons.length; i++) {%>'
        + '<input type="button" data-sitedialog-button-id="<%= model.buttons[i].buttonId %>" class="btn <%= model.buttons[i].buttonClass %>" value="<%=model.buttons[i].text%>"/>'
        + '<% } %>'
        + '</div>'
        + '<% } %>'
        + '</div>'
        + '</div>'
        + '</div>');
    options = $.extend({
        dialogClass: '',
        title: '',
        body: '',
        close: null,
        buttons: []
    }, options);
    if (options.buttons) {
        for (var i = 0; i < options.buttons.length; i++) {
            options.buttons[i].buttonId = ("button_".concat(Math.random())).replace(".", "");
        }
    }
    var htmlText = modalTemplate(options);
    var $dialog = $(htmlText);
    var skipClose = false;
    $dialog.modal('show');
    if (options.buttons) {
        for (var i = 0; i < options.buttons.length; i++) {
            if (options.buttons[i].click) {
                $("input[data-sitedialog-button-id='".concat(options.buttons[i].buttonId, "']"), $dialog).click(options.buttons[i].click);
            }
        }
    }
    $dialog.on('hidden.bs.modal', function () {
        $dialog.remove();
        if (options.close && !skipClose) {
            options.close();
        }
    });
    return {
        container: $dialog,
        close: function () {
            skipClose = true;
            $dialog.modal("hide");
        }
    };
}
var PopupIframeResult = {
    OK: "OK",
    Cancel: "Cancel"
};
var PopupContext = (function () {
    function PopupContext(callContext, onOK, onCancel) {
        this.Result = null;
        this.ReturnInfo = null;
        this._callContext = callContext;
        this._onOK = onOK;
        this._onCancel = onCancel;
    }
    PopupContext.prototype.FireClose = function (sender) {
        var _eventArgs = { ReturnInfo: this.ReturnInfo, CallContext: this._callContext };
        if (this.Result === PopupIframeResult.OK && this._onOK != null)
            this._onOK(sender, _eventArgs);
        else if ((this.Result == null || this.Result === PopupIframeResult.Cancel) && this._onCancel != null)
            this._onCancel(sender, _eventArgs);
    };
    ;
    return PopupContext;
}());
var PopupIframeManager = {
    CurrentModalPopup: null,
    ModalOnLoad: function () {
        var dv = $('#divModalIframe');
        var dvLoading = dv.find('#divModalIframeLoading');
        var dvIfrHolder = dv.find("#divModalIframeHolder");
        dvLoading.hide();
        dvIfrHolder.show();
    },
    ShowModal: function (url, width, height, title, callContext, onOK, onCancel) {
        setTimeout(function () {
            url = url + (url.indexOf('?') > 0 ? "&" : "?") + "rnd=" + Math.random();
            var dv = $("<div id='divModalIframe' style='display:none; overflow:hidden;'><div id='divModalIframeLoading' style='display:none; color:Gray; padding:15px'>Loading...</div><div id='divModalIframeHolder' style='width:100%; height:100%;'></div></div>");
            var dvLoading = dv.find('#divModalIframeLoading');
            var dvIfrHolder = dv.find("#divModalIframeHolder");
            var isIE = navigator.appName === 'Microsoft Internet Explorer';
            var rndID = Math.random();
            var tplIfr;
            if (isIE) {
                tplIfr = '<iframe id="' + rndID + '" width="100%" height="100%" onload="PopupIframeManager.ModalOnLoad();" marginwidth="0" marginheight="0" frameborder="0" scrolling="auto">Your browser does not support iframes</iframe>';
            }
            else {
                tplIfr = '<iframe id="' + rndID + '" width="100%" height="100%" onload="PopupIframeManager.ModalOnLoad();" marginwidth="0" marginheight="0" frameborder="0" scrolling="auto" src="' + url + '">Your browser does not support iframes</iframe>';
            }
            dvIfrHolder.hide();
            dvIfrHolder.html(tplIfr);
            if (isIE) {
                dvIfrHolder.find('iframe')[0].src = url;
            }
            dvLoading.show();
            PopupIframeManager.CurrentModalPopup = new PopupContext(callContext, onOK, onCancel);
            dv.dialog({
                modal: true,
                width: width,
                height: height,
                title: title,
                buttons: null,
                close: function () {
                    dvIfrHolder.html("");
                    dv.remove();
                    if (PopupIframeManager.CurrentModalPopup != null) {
                        PopupIframeManager.CurrentModalPopup.FireClose(null);
                        PopupIframeManager.CurrentModalPopup = null;
                    }
                },
                resizable: false
            });
        }, 0);
    },
    CloseModal: function (returnInfo, isOK) {
        if (PopupIframeManager.CurrentModalPopup != null) {
            PopupIframeManager.CurrentModalPopup.Result = isOK ? PopupIframeResult.OK : PopupIframeResult.Cancel;
            PopupIframeManager.CurrentModalPopup.ReturnInfo = returnInfo;
        }
        $('#divModalIframe').dialog("close");
    }
};
function appSaveFormDialog(fetchUrl, dialogOptions) {
    var defSaveFormDialog = $.Deferred();
    var dialog = appDialogShow({
        title: dialogOptions.title,
        dialogClass: dialogOptions.dialogClass,
        body: dialogOptions.bodyHtml,
        buttons: [
            {
                text: "Закрыть",
                buttonClass: 'btn-secondary',
                click: function () {
                    dialog.close();
                }
            },
            {
                text: dialogOptions.saveBtnText,
                buttonClass: "btn-primary",
                click: function () {
                    var $form = $('form', dialog.container);
                    if (!$form.valid())
                        return;
                    var $saveButton = $(this);
                    var originalValue = $saveButton.val();
                    $saveButton.prop('disabled', true).val("".concat(originalValue, "..."));
                    var postUrl = $form.attr('action');
                    var request;
                    if ($form.attr("enctype") === "multipart/form-data") {
                        var formElem = $form[0];
                        var formdata = new FormData(formElem);
                        request = $.ajax({
                            type: "POST",
                            url: postUrl,
                            data: formdata,
                            processData: false,
                            contentType: false,
                        });
                    }
                    else {
                        var params = $form.serialize();
                        request = $.post(postUrl, params);
                    }
                    request.done(function (data, textStatus, xhr) {
                        if (xhr.getResponseHeader('CloseDialog') === "1") {
                            defSaveFormDialog.resolve(xhr.getResponseHeader('CloseDialogResult'));
                            dialog.close();
                            return;
                        }
                        dialog.container.find(".modal-body").html(data);
                        site.validators.refreshValidators(dialog.container);
                    }).always(function () {
                        $saveButton.prop('disabled', false).val(originalValue);
                    });
                }
            }
        ]
    });
    var handleResponse = function (data) {
        dialog.container.find(".modal-body").html(data);
        site.validators.refreshValidators(dialog.container);
    };
    $.get(fetchUrl, dialogOptions.fetchParams, function (data) {
        if (dialog.container.is(':visible')) {
            handleResponse(data);
        }
        else {
            dialog.container.on('shown.bs.modal', function () {
                handleResponse(data);
            });
        }
    });
    return defSaveFormDialog.promise();
}
var appSaveFormDialogOptions = (function () {
    function appSaveFormDialogOptions() {
        this.fetchParams = null;
        this.title = "Dialog";
        this.saveBtnText = "Save changes";
        this.bodyHtml = "<p>Loading...</p>";
        this.dialogClass = "";
    }
    return appSaveFormDialogOptions;
}());
var avdImport = (function () {
    function avdImport(args) {
        var _this = this;
        this.uiElements = {
            submitBtn: null,
            importBtnLoading: null,
            form: null,
            progressContainer: null,
            progressBar: null,
            formContainer: null,
            loading: null,
        };
        this._args = args;
        this.uiElements.submitBtn = $("#importBtn");
        this.uiElements.importBtnLoading = $("#importBtn_loading");
        this.uiElements.form = $("#avd-import-form");
        this.uiElements.progressContainer = $("#progress-container");
        this.uiElements.progressBar = $("[role='progressbar']", this.uiElements.progressContainer);
        this.uiElements.formContainer = $("#form-container");
        this.uiElements.loading = $("#avd-import-loading");
        this.uiElements.formContainer.hide();
        $.get(this._args.getAvdProductImportStatusUrl).done(function (response) {
            var isActive = response.data.isActive;
            _this.uiElements.loading.hide();
            if (isActive) {
                _this.uiElements.progressContainer.show();
                _this.updateImportStatus();
            }
            else {
                _this.uiElements.formContainer.show();
            }
        });
        this.subscribeToEvents();
    }
    avdImport.prototype.subscribeToEvents = function () {
        var _this = this;
        this.uiElements.submitBtn.click(function () {
            var formData = new FormData();
            formData.append('file', $('#xls-file-input')[0].files[0]);
            formData.append('CurrencyRate', $('#CurrencyRate').val().toString());
            _this.uiElements.formContainer.hide();
            _this.uiElements.progressContainer.show();
            $.ajax({
                url: _this.uiElements.form.attr("action"),
                type: "POST",
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (!response.success) {
                        alert(response.data);
                        _this.uiElements.formContainer.show();
                        _this.uiElements.progressContainer.hide();
                    }
                }
            });
            setTimeout(function () { _this.updateImportStatus(); }, 2000);
        });
    };
    avdImport.prototype.updateImportStatus = function () {
        var _this = this;
        $.get(this._args.getAvdProductImportStatusUrl).done(function (response) {
            var _a = response.data, percent = _a.percent, message = _a.message;
            if (percent == 100 || percent == 0) {
                _this.uiElements.progressBar.removeClass("active");
            }
            else {
                setTimeout(function () { _this.updateImportStatus(); }, 2000);
            }
            $("#import-progress-status").text(message);
            _this.uiElements.progressBar.css("width", percent + "%").text(percent + "%");
        });
    };
    return avdImport;
}());
var avdImportArgs = (function () {
    function avdImportArgs() {
    }
    return avdImportArgs;
}());
var avtoliderImport = (function () {
    function avtoliderImport(args) {
        var _this = this;
        this.uiElements = {
            submitBtn: null,
            importBtnLoading: null,
            form: null,
            progressContainer: null,
            progressBar: null,
            formContainer: null,
            loading: null,
        };
        this._args = args;
        this.uiElements.submitBtn = $("#importBtn");
        this.uiElements.importBtnLoading = $("#importBtn_loading");
        this.uiElements.form = $("#avtolider-import-form");
        this.uiElements.progressContainer = $("#progress-container");
        this.uiElements.progressBar = $("[role='progressbar']", this.uiElements.progressContainer);
        this.uiElements.formContainer = $("#form-container");
        this.uiElements.loading = $("#avtolider-import-loading");
        this.uiElements.formContainer.hide();
        $.get(this._args.getAvtoliderProductImportStatusUrl).done(function (response) {
            var isActive = response.data.isActive;
            _this.uiElements.loading.hide();
            if (isActive) {
                _this.uiElements.progressContainer.show();
                _this.updateImportStatus();
            }
            else {
                _this.uiElements.formContainer.show();
            }
        });
        this.subscribeToEvents();
    }
    avtoliderImport.prototype.subscribeToEvents = function () {
        var _this = this;
        this.uiElements.submitBtn.click(function () {
            var formData = new FormData();
            formData.append('file', $('#xls-file-input')[0].files[0]);
            formData.append('CurrencyRate', $('#CurrencyRate').val().toString());
            _this.uiElements.formContainer.hide();
            _this.uiElements.progressContainer.show();
            $.ajax({
                url: _this.uiElements.form.attr("action"),
                type: "POST",
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (!response.success) {
                        alert(response.data);
                        _this.uiElements.formContainer.show();
                        _this.uiElements.progressContainer.hide();
                    }
                }
            });
            setTimeout(function () { _this.updateImportStatus(); }, 2000);
        });
    };
    avtoliderImport.prototype.updateImportStatus = function () {
        var _this = this;
        $.get(this._args.getAvtoliderProductImportStatusUrl).done(function (response) {
            var _a = response.data, percent = _a.percent, message = _a.message;
            if (percent == 100 || percent == 0) {
                _this.uiElements.progressBar.removeClass("active");
            }
            else {
                setTimeout(function () { _this.updateImportStatus(); }, 2000);
            }
            $("#import-progress-status").text(message);
            _this.uiElements.progressBar.css("width", percent + "%").text(percent + "%");
        });
    };
    return avtoliderImport;
}());
var avtoliderImportArgs = (function () {
    function avtoliderImportArgs() {
    }
    return avtoliderImportArgs;
}());
var busmarketImport = (function () {
    function busmarketImport(args) {
        var _this = this;
        this.uiElements = {
            submitBtn: null,
            importBtnLoading: null,
            form: null,
            progressContainer: null,
            progressBar: null,
            formContainer: null,
            loading: null,
        };
        this._args = args;
        this.uiElements.submitBtn = $("#importBtn");
        this.uiElements.importBtnLoading = $("#importBtn_loading");
        this.uiElements.form = $("#busmarket-import-form");
        this.uiElements.progressContainer = $("#progress-container");
        this.uiElements.progressBar = $("[role='progressbar']", this.uiElements.progressContainer);
        this.uiElements.formContainer = $("#form-container");
        this.uiElements.loading = $("#busmarket-import-loading");
        this.uiElements.formContainer.hide();
        $.get(this._args.getBusmarketProductImportStatusUrl).done(function (response) {
            var isActive = response.data.isActive;
            _this.uiElements.loading.hide();
            if (isActive) {
                _this.uiElements.progressContainer.show();
                _this.updateImportStatus();
            }
            else {
                _this.uiElements.formContainer.show();
            }
        });
        this.subscribeToEvents();
    }
    busmarketImport.prototype.subscribeToEvents = function () {
        var _this = this;
        this.uiElements.submitBtn.click(function () {
            if (!_this.uiElements.form.valid())
                return;
            var formData = new FormData();
            _this.uiElements.formContainer.hide();
            _this.uiElements.progressContainer.show();
            $.ajax({
                url: _this.uiElements.form.attr("action"),
                type: "POST",
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (!response.success) {
                        alert(response.data);
                        _this.uiElements.formContainer.show();
                        _this.uiElements.progressContainer.hide();
                    }
                }
            });
            setTimeout(function () { _this.updateImportStatus(); }, 2000);
        });
    };
    busmarketImport.prototype.updateImportStatus = function () {
        var _this = this;
        $.get(this._args.getBusmarketProductImportStatusUrl).done(function (response) {
            var _a = response.data, percent = _a.percent, message = _a.message;
            if (percent == 100 || percent == 0) {
                _this.uiElements.progressBar.removeClass("active");
            }
            else {
                setTimeout(function () { _this.updateImportStatus(); }, 2000);
            }
            $("#import-progress-status").text(message);
            _this.uiElements.progressBar.css("width", percent + "%").text(percent + "%");
        });
    };
    return busmarketImport;
}());
var busmarketImportArgs = (function () {
    function busmarketImportArgs() {
    }
    return busmarketImportArgs;
}());
var omegaImport = (function () {
    function omegaImport(args) {
        var _this = this;
        this.uiElements = {
            submitBtn: null,
            importBtnLoading: null,
            form: null,
            progressContainer: null,
            progressBar: null,
            formContainer: null,
            loading: null,
        };
        this._args = args;
        this.uiElements.submitBtn = $("#importBtn");
        this.uiElements.importBtnLoading = $("#importBtn_loading");
        this.uiElements.form = $("#omega-import-form");
        this.uiElements.progressContainer = $("#progress-container");
        this.uiElements.progressBar = $("[role='progressbar']", this.uiElements.progressContainer);
        this.uiElements.formContainer = $("#form-container");
        this.uiElements.loading = $("#omega-import-loading");
        this.uiElements.formContainer.hide();
        $.get(this._args.getOmegaProductImportStatusUrl).done(function (response) {
            var isActive = response.data.isActive;
            _this.uiElements.loading.hide();
            if (isActive) {
                _this.uiElements.progressContainer.show();
                _this.updateImportStatus();
            }
            else {
                _this.uiElements.formContainer.show();
            }
        });
        this.subscribeToEvents();
    }
    omegaImport.prototype.subscribeToEvents = function () {
        var _this = this;
        this.uiElements.submitBtn.click(function () {
            if (!_this.uiElements.form.valid())
                return;
            var formData = new FormData();
            _this.uiElements.formContainer.hide();
            _this.uiElements.progressContainer.show();
            $.ajax({
                url: _this.uiElements.form.attr("action"),
                type: "POST",
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (!response.success) {
                        alert(response.data);
                        _this.uiElements.formContainer.show();
                        _this.uiElements.progressContainer.hide();
                    }
                }
            });
            setTimeout(function () { _this.updateImportStatus(); }, 2000);
        });
    };
    omegaImport.prototype.updateImportStatus = function () {
        var _this = this;
        $.get(this._args.getOmegaProductImportStatusUrl).done(function (response) {
            var _a = response.data, percent = _a.percent, message = _a.message;
            if (percent == 100 || percent == 0) {
                _this.uiElements.progressBar.removeClass("active");
            }
            else {
                setTimeout(function () { _this.updateImportStatus(); }, 2000);
            }
            $("#import-progress-status").text(message);
            _this.uiElements.progressBar.css("width", percent + "%").text(percent + "%");
        });
    };
    return omegaImport;
}());
var omegaImportArgs = (function () {
    function omegaImportArgs() {
    }
    return omegaImportArgs;
}());
var productDetails = (function () {
    function productDetails(args) {
        this.uiElements = {
            form: null,
            qtyOrderedTextBox: null,
            addToCartBtn: null,
            similarProductsSection: null,
            carSection: null,
            categoryProductsSection: null,
            productCarsLink: null,
            productComponentsSection: null,
            relatedProductsSection: null,
        };
        this._args = null;
        this._args = args;
        this.qtyAvail = args.qtyAvail;
        this.uiElements.form = $("#add-to-cart-form");
        this.uiElements.qtyOrderedTextBox = $("#QtyOrdered", this.uiElements.form);
        this.uiElements.addToCartBtn = $("#addToCartBtn");
        this.uiElements.similarProductsSection = $("#similar-products-section");
        this.uiElements.categoryProductsSection = $("#category-products-section");
        this.uiElements.carSection = $("#car-section");
        this.uiElements.productCarsLink = $(".product-cars-link");
        this.uiElements.productComponentsSection = $("#product-components-section");
        this.uiElements.relatedProductsSection = $("#related-products-section");
        if (this._args.productGroupId) {
            this.loadProductComponents();
        }
        if (this._args.similarProductGroupId) {
            this.loadSimilarProducts(false);
        }
        if (this._args.categoryId && this._args.carModelTypeId) {
            this.loadCategoryProducts();
        }
        if (this._args.relatedProductGroupId) {
            this.loadRelatedProducts();
        }
        $('.characteristic-item [data-toggle="tooltip"]').tooltip();
        this.subscribeToEvents();
    }
    productDetails.prototype.subscribeToEvents = function () {
        var _this = this;
        this.uiElements.addToCartBtn.click(function () {
            _this.addToCart();
        });
        $(".product-thumbs__item").click(function (e) {
            _this.switchImage($(e.currentTarget));
            e.preventDefault();
        });
        this.uiElements.productCarsLink.click(function (e) {
            var options = {
                title: _this._args.applicabilityModalTitle,
                dialogClass: 'modal-lg',
                okText: _this._args.closeButtonText
            };
            var manufacturerId = $(e.target).data("manufacturer-id");
            var productCarsUrl = _this._args.getProductCarsUrl + "&manufacturerId=" + manufacturerId;
            if (_this._args.categoryId)
                productCarsUrl += "&categoryId=" + _this._args.categoryId;
            $.get(productCarsUrl).done(function (response) {
                site.dialogs.alert(response, null, options);
            });
        });
        $("#mainImageLink").click(function (e) {
            var currentImageUrl = $(e.currentTarget).find("img").attr("src");
            var imagesArray = [{
                    src: currentImageUrl,
                }];
            $(".product-thumbs__item a").each(function (i, el) {
                var thumbUrl = $(el).attr("href");
                if (currentImageUrl !== thumbUrl) {
                    imagesArray.push({
                        src: thumbUrl,
                    });
                }
            });
            $.fancybox.open(imagesArray, {
                protect: true,
                loop: true
            });
        });
        $(".hade-text-before").click(function () {
            $(".supplier-description-container").removeClass("collapsed");
        });
        this.uiElements.similarProductsSection.on('click', '.showAllSimilarProducts:not(.processed)', function (e) {
            $(e.currentTarget).addClass('processed');
            _this.loadSimilarProducts(true);
        });
    };
    productDetails.prototype.switchImage = function (thumb) {
        $('.product-thumbs__item').removeClass('product-thumbs__item--active');
        var bigUrl = $('a', thumb).attr('href');
        thumb.addClass('product-thumbs__item--active');
        $('.mainImage img').attr('src', bigUrl);
    };
    productDetails.prototype.addToCart = function () {
        var _this = this;
        var url = this.uiElements.form.attr("action");
        var qtyOrdered = this.uiElements.qtyOrderedTextBox.val();
        this.uiElements.form.validate({
            errorClass: "field-validation-error"
        });
        if (!this._args.isAlwaysAvailable) {
            this.uiElements.qtyOrderedTextBox.rules("add", {
                required: true,
                min: 1,
                max: Number(this.qtyAvail),
                digits: true,
                messages: {
                    required: "Please, Choose qty",
                    max: jQuery.validator.format("Qty ordered must be equal or lower than available {0}")
                }
            });
        }
        if (!this.uiElements.form.valid())
            return;
        $.post(url, this.uiElements.form.serialize()).done(function () {
            eventListener.trigger("product-added-to-cart", null);
            _this.qtyAvail = _this.qtyAvail - qtyOrdered;
            _this.uiElements.qtyOrderedTextBox.val(1);
            window.ga('send', 'event', 'Products', 'AddToCart', 'Details', {
                'dimension1': _this._args.gaUserName,
                'dimension2': _this._args.productCode
            });
        });
    };
    productDetails.prototype.loadProductComponents = function () {
        var _this = this;
        $.get(this._args.getProductComponentsUrl).done(function (response) {
            _this.uiElements.productComponentsSection.html(response);
            $('[data-toggle="tooltip"]', _this.uiElements.productComponentsSection).tooltip();
            _this.subscribeToAddToCartEvents(_this.uiElements.productComponentsSection);
        });
    };
    productDetails.prototype.loadCategoryProducts = function () {
        var _this = this;
        $.get(this._args.getCategoryProductsUrl).done(function (response) {
            _this.uiElements.categoryProductsSection.html(response);
            $('[data-toggle="tooltip"]', _this.uiElements.categoryProductsSection).tooltip();
            _this.subscribeToAddToCartEvents(_this.uiElements.categoryProductsSection);
        });
    };
    productDetails.prototype.loadSimilarProducts = function (showAll) {
        var _this = this;
        $.get(this._args.getSimilarProductsUrl + '&productId=' + this._args.productId + '&showAll=' + showAll).done(function (response) {
            _this.uiElements.similarProductsSection.html(response);
            $('[data-toggle="tooltip"]', _this.uiElements.similarProductsSection).tooltip();
            _this.subscribeToAddToCartEvents(_this.uiElements.similarProductsSection);
        });
    };
    productDetails.prototype.loadRelatedProducts = function () {
        var _this = this;
        $.get(this._args.getRelatedProductsUrl).done(function (response) {
            _this.uiElements.relatedProductsSection.html(response);
            $('[data-toggle="tooltip"]', _this.uiElements.relatedProductsSection).tooltip();
            _this.subscribeToAddToCartEvents(_this.uiElements.relatedProductsSection);
        });
    };
    productDetails.prototype.subscribeToAddToCartEvents = function (sectionContainer) {
        var _this = this;
        sectionContainer.on("click", "a[data-add-to-cart]", function (e) {
            var productId = $(e.currentTarget).data("add-to-cart");
            $.post(_this._args.addToCartUrl, { productId: productId }).done(function (addCartResponse) {
                if (!addCartResponse.success)
                    alert(addCartResponse.data);
                var productCode = $(e.currentTarget).closest("tr").data("product-code");
                window.ga('send', 'event', 'Products', 'AddToCart', 'Analog', {
                    'dimension1': _this._args.gaUserName,
                    'dimension2': productCode
                });
                eventListener.trigger("product-added-to-cart", null);
            });
        });
    };
    return productDetails;
}());
var productDetailsArgs = (function () {
    function productDetailsArgs() {
    }
    return productDetailsArgs;
}());
var searchByCarHelper = (function () {
    function searchByCarHelper(args) {
        this.uiElements = {
            yearDropdown: null,
            manufacturerDropdown: null,
            modelDropdown: null,
            carTypeDropdown: null,
            categoryHidden: null
        };
        this._args = null;
        this._args = args;
        this.uiElements.manufacturerDropdown = $(this._args.manufacturerDropdownSelector);
        this.uiElements.yearDropdown = $(this._args.yearDropdownSelector);
        this.uiElements.modelDropdown = $(this._args.modelDropdownSelector);
        this.uiElements.carTypeDropdown = $(this._args.carTypeDropdownSelector);
        this.uiElements.categoryHidden = $("#categoryIdHidden ");
        this.uiElements.yearDropdown.select2();
        this.uiElements.manufacturerDropdown.select2();
        this.uiElements.modelDropdown.select2();
        this.uiElements.carTypeDropdown.select2();
        this.subscribeToEvents();
    }
    searchByCarHelper.prototype.subscribeToEvents = function () {
        var _this = this;
        this.uiElements.yearDropdown.change(function () {
            _this.uiElements.manufacturerDropdown.prop("disabled", true);
            _this.uiElements.manufacturerDropdown.val("");
            _this.uiElements.modelDropdown.prop("disabled", true);
            _this.uiElements.modelDropdown.val("");
            _this.uiElements.carTypeDropdown.prop("disabled", true);
            _this.uiElements.carTypeDropdown.val("");
            if (!_this.uiElements.yearDropdown.val()) {
                _this.uiElements.manufacturerDropdown.prop("disabled", false);
                _this.uiElements.modelDropdown.prop("disabled", false);
                _this.uiElements.carTypeDropdown.prop("disabled", false);
                return;
            }
            _this.uiElements.manufacturerDropdown.select2("destroy");
            _this.uiElements.modelDropdown.select2("destroy");
            _this.uiElements.carTypeDropdown.select2("destroy");
            $.get(_this._args.getManufacturersForDropdownUrl, { year: _this.uiElements.yearDropdown.val() }).done(function (response) {
                _this.uiElements.manufacturerDropdown.empty();
                $("<option />", {
                    val: null,
                    text: _this._args.dropdownDefaultText,
                }).appendTo(_this.uiElements.manufacturerDropdown);
                response.forEach(function (item, i, arr) {
                    $("<option />", {
                        val: item.value,
                        text: item.text,
                        selected: item.selected
                    }).appendTo(_this.uiElements.manufacturerDropdown);
                });
                _this.uiElements.manufacturerDropdown.select2();
                _this.uiElements.manufacturerDropdown.prop("disabled", false);
                _this.uiElements.modelDropdown.select2();
                _this.uiElements.modelDropdown.prop("disabled", false);
                _this.uiElements.carTypeDropdown.select2();
                _this.uiElements.carTypeDropdown.prop("disabled", false);
            });
        });
        this.uiElements.manufacturerDropdown.change(function () {
            _this.uiElements.modelDropdown.prop("disabled", true);
            _this.uiElements.modelDropdown.val("");
            _this.uiElements.carTypeDropdown.prop("disabled", true);
            _this.uiElements.carTypeDropdown.val("");
            if (!_this.uiElements.manufacturerDropdown.val()) {
                _this.uiElements.modelDropdown.prop("disabled", false);
                _this.uiElements.carTypeDropdown.prop("disabled", false);
                return;
            }
            _this.uiElements.modelDropdown.select2("destroy");
            _this.uiElements.carTypeDropdown.select2("destroy");
            $.get(_this._args.getCarModelsForDropdownByCodeUrl, {
                manufacturerCode: _this.uiElements.manufacturerDropdown.val(),
                year: _this.uiElements.yearDropdown.val()
            }).done(function (response) {
                _this.uiElements.modelDropdown.empty();
                $("<option />", {
                    val: null,
                    text: _this._args.dropdownDefaultText,
                }).appendTo(_this.uiElements.modelDropdown);
                response.forEach(function (item, i, arr) {
                    $("<option />", {
                        val: item.value,
                        text: item.text,
                        selected: item.selected
                    }).appendTo(_this.uiElements.modelDropdown);
                });
                _this.uiElements.modelDropdown.select2();
                _this.uiElements.modelDropdown.prop("disabled", false);
                _this.uiElements.carTypeDropdown.select2();
                _this.uiElements.carTypeDropdown.prop("disabled", false);
            });
        });
        this.uiElements.modelDropdown.change(function () {
            _this.uiElements.carTypeDropdown.prop("disabled", true);
            _this.uiElements.carTypeDropdown.val("");
            if (!_this.uiElements.modelDropdown.val()) {
                _this.uiElements.carTypeDropdown.prop("disabled", false);
                return;
            }
            _this.uiElements.carTypeDropdown.select2("destroy");
            $.get(_this._args.getCarModelTypesForDropdownByCodeUrl, { modelCode: _this.uiElements.modelDropdown.val(), manufacturerCode: _this.uiElements.manufacturerDropdown.val() }).done(function (response) {
                $("<option />", {
                    val: null,
                    text: _this._args.dropdownDefaultText,
                }).appendTo(_this.uiElements.carTypeDropdown);
                response.forEach(function (item, i, arr) {
                    $("<option />", {
                        val: item.value,
                        text: item.text
                    }).appendTo(_this.uiElements.carTypeDropdown);
                });
                _this.uiElements.carTypeDropdown.select2();
                _this.uiElements.carTypeDropdown.prop("disabled", false);
            });
        });
    };
    return searchByCarHelper;
}());
var searchByCarHelperArgs = (function () {
    function searchByCarHelperArgs() {
    }
    return searchByCarHelperArgs;
}());
var layoutHelper = (function () {
    function layoutHelper(args) {
        this.uiElements = {
            cartInfoContainer: null,
        };
        this._args = null;
        this._args = args;
        this.uiElements.cartInfoContainer = $("#cart-info-container");
        this.subscribeToEvents();
    }
    layoutHelper.prototype.subscribeToEvents = function () {
        var _this = this;
        eventListener.on("product-added-to-cart", function () {
            $.get(_this._args.getCartInfoUrl).done(function (response) {
                _this.uiElements.cartInfoContainer.html(response);
                $.notify({ message: _this._args.addedToCartMessage }, { type: "success" });
            });
        }, null);
        $("#currencyTypeDropdown").on("click", "li[data-currency-type]", function (e) {
            var currencyType = $(e.currentTarget).data("currency-type");
            $.post(_this._args.setCurrentCurrencyUrl, { currency: currencyType }).done(function (response) {
                if (!response.success)
                    alert(response.data);
                location.reload();
            });
        });
        this.uiElements.cartInfoContainer.on("click", ".goToCartLink", function () {
            window.ga('send', 'event', 'Cart', 'GoToCart', null, { 'dimension1': this._args.gaUserName });
        });
    };
    return layoutHelper;
}());
var layoutHelperArgs = (function () {
    function layoutHelperArgs() {
    }
    return layoutHelperArgs;
}());
var tdProductDetails = (function () {
    function tdProductDetails(args) {
        this.uiElements = {
            productCarsModal: null,
            productCarsLink: null,
            form: null,
            importBtn: null,
            importBtnLoading: null
        };
        this._args = null;
        this._args = args;
        this.uiElements.productCarsModal = $("#product-cars-modal");
        this.uiElements.productCarsLink = $(".product-cars-link");
        this.uiElements.form = $("#import-product-form");
        this.uiElements.importBtn = $("#importProductBtn");
        this.uiElements.importBtnLoading = $("#importProductBtnLoading");
        $('.characteristic-item [data-toggle="tooltip"]').tooltip();
        this.subscribeToEvents();
    }
    tdProductDetails.prototype.subscribeToEvents = function () {
        var _this = this;
        this.uiElements.productCarsLink.click(function (e) {
            _this.uiElements.productCarsModal.modal("show");
        });
        this.uiElements.importBtn.click(function (e) {
            _this.importProduct();
        });
        $(".product-thumbs__item").click(function (e) {
            _this.switchImage($(e.currentTarget));
            e.preventDefault();
        });
        $("#mainImageLink").click(function (e) {
            var currentImageUrl = $(e.currentTarget).find("img").attr("src");
            var imagesArray = [{
                    src: currentImageUrl,
                }];
            $(".product-thumbs__item a").each(function (i, el) {
                var thumbUrl = $(el).attr("href");
                if (currentImageUrl !== thumbUrl) {
                    imagesArray.push({
                        src: thumbUrl,
                    });
                }
            });
            $.fancybox.open(imagesArray, {
                protect: true,
                loop: true
            });
        });
    };
    tdProductDetails.prototype.switchImage = function (thumb) {
        $('.product-thumbs__item').removeClass('product-thumbs__item--active');
        var bigUrl = $('a', thumb).attr('href');
        thumb.addClass('product-thumbs__item--active');
        $('.mainImage img').attr('src', bigUrl);
    };
    tdProductDetails.prototype.importProduct = function () {
        var _this = this;
        var url = this.uiElements.form.attr("action");
        this.uiElements.importBtn.prop("disabled", true);
        this.uiElements.importBtnLoading.show();
        $.post(url, this.uiElements.form.serialize()).done(function () {
            $.notify({ message: "Товар успешно добавлен" }, { type: "success" });
            _this.uiElements.importBtnLoading.hide();
        });
    };
    return tdProductDetails;
}());
var tdProductDetailsArgs = (function () {
    function tdProductDetailsArgs() {
    }
    return tdProductDetailsArgs;
}());
//# sourceMappingURL=/app-out/app.js.map